import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { IndicatorField } from "src/app/model/dashboard/indicators-data";
import { DatasetFieldFloatingOption } from "src/app/model/dataset/dataset-field-floating-option";

@Component({
    selector: "map-indicators-edit-dialog",
    templateUrl: "./indicators-edit-dialog.component.html",
    styleUrls: ["./indicators-edit-dialog.component.scss"],
})
export class IndicatorsEditDialog {
    readonly TENSORFLIGHT_KEYWORD = 'tensorflight';
    readonly MUNICHRE_KEYWORD = 'munichre_';
    title: string;
    cancelButton: string;
    confirmButton: string;
    displayedColumns: string[];
    dataSource: MatTableDataSource<any>;
    locationsDataSource: MatTableDataSource<any>;
    formulasDataSource: MatTableDataSource<any>;
    indicators: any[];

    get indicatorOptions() {
        return Object.keys(DatasetFieldFloatingOption);
    }

    constructor(
        public dialogRef: MatDialogRef<IndicatorsEditDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.title = 'Manage Indicators';
        this.cancelButton = "Cancel";
        this.confirmButton = "Save";
        
        // Handle data with separate locations and formulas arrays
        const locationFields = data.locations || [];
        const formulaFields = data.formulas || [];
        
        // Combine for backward compatibility
        this.indicators = [...locationFields, ...formulaFields];
        
        // Create filtered datasources for each table
        this.locationsDataSource = new MatTableDataSource<any>(
            locationFields.filter(indicator => {
                // Convert id to string first to allow includes() method
                const idStr = String(indicator.id);
                return !idStr.includes(this.TENSORFLIGHT_KEYWORD) && 
                       !idStr.includes(this.MUNICHRE_KEYWORD);
            })
        );

        this.formulasDataSource = new MatTableDataSource<any>(
            formulaFields.filter(indicator => {
                // Convert id to string first to allow includes() method
                const idStr = String(indicator.id);
                return !idStr.includes(this.TENSORFLIGHT_KEYWORD) && 
                       !idStr.includes(this.MUNICHRE_KEYWORD);
            })
        );

        this.displayedColumns = [
            "id",
            "name",
            "isIndicators",
            "indicatorOptions",
        ];
    }

    setIndicatorOption(field: IndicatorField) {
        if (field.isIndicators) {
            field.indicatorsOption = DatasetFieldFloatingOption.SUM;
        } else {
            field.indicatorsOption = null;
        }
    }

    onConfirm(): void {
        // Ensure all necessary properties are set on each indicator
        const locations = this.locationsDataSource.data.map(location => {
            // Convert id to number if it's a string
            const id = typeof location.id === 'string' ? parseInt(location.id, 10) : location.id;
            
            return {
                ...location,
                id: id,
                type: 'LOCATION', // Correctly set to 'LOCATION'
                indicators: location.isIndicators,
                isIndicators: location.isIndicators,
                indicatorsOption: location.isIndicators ? location.indicatorsOption || 'SUM' : null,
                sequence: location.sequence || 0
            };
        });
        
        const formulas = this.formulasDataSource.data.map(formula => {
            // Convert id to number if it's a string
            const id = typeof formula.id === 'string' ? parseInt(formula.id, 10) : formula.id;
            
            return {
                ...formula,
                id: id,
                type: 'FORMULA', // Correctly set to 'FORMULA'
                indicators: formula.isIndicators,
                isIndicators: formula.isIndicators,
                indicatorsOption: formula.isIndicators ? formula.indicatorsOption || 'SUM' : null,
                sequence: formula.sequence || 0
            };
        });
        
        // Return data in the format expected by the dashboard component
        this.dialogRef.close({
            locations: locations,
            formulas: formulas
        });
    }

    onDismiss(): void {
        this.dialogRef.close(false);
    }
}